export const columns = [
  {
    title: "文件名称",
    width: 300,
    key: "name",
    dataIndex: "name",
  },
  {
    title: "文件类型",
    width: 80,
    key: "suffix",
    dataIndex: "suffix",
  },
  {
    title: "文件大小",
    width: 100,
    key: "size",
    slots: { customRender: "size" },
  },
  {
    title: "创建人",
    width: 100,
    key: "createName",
    dataIndex: "createName",
  },
  {
    title: "创建时间",
    width: 200,
    key: "createTime",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    width: 140,
    fixed: "right",
    key: "operation",
    slots: { customRender: "action" },
  },
];
